import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';

import HomePageRevamp from './HomePageRevamp';
import UserProfile from '../User/UserProfile/UserProfile';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('dashboard');

  return (
    <Switch>
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission exact path="/" component={HomePageRevamp} />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/dashboard"
        component={HomePageRevamp}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/dashboard/user/profile"
        component={UserProfile}
      />
    </Switch>
  );
};

export default Routes;
